<template>
  <div>
    <van-tabs color="#1989fa" v-model="active">
      <van-tab
        :title="item.name"
        v-for="(item, index) in productList"
        :key="index"
      >
        <van-card
          v-for="(ctem, index) in item.value"
          :key="index"
          :desc="ctem.digest"
          :title="ctem.name"
          :thumb="ctem.img"
          @click.prevent="proDetails(ctem.id)"
        >
        </van-card>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import URL from '@/api/api'
export default {
  data() {
    return {
      active:0,
      productList: []
    };
  },
  mounted(){
    this.fatchdata()
  },
  methods: {
    fatchdata(){
      this.$fetchGet(URL.hotProduct.url,{hot:1}).then(res=>{
        this.productList=res.data;
      })
    },
    proDetails(id) {
        this.$router.push({path:'/productDetails/details',query:{id:id}})
    },
  },
};
</script>
<style scoped>
.van-tab__pane {
  width: 95%;
  margin: 10px auto;
}
.van-card__title {
  max-height: 32px;
  font-weight: 600;
  line-height: 40px;
  font-size: 16px;
}
</style>